import { RefObject, useMemo } from 'react';

import { Site } from '../ColumnSections/Site.tsx';
import { ViewMode } from '../types.ts';

export const useSitesByID = (
  viewMode: ViewMode,
  opinionOfSiteValueRef: RefObject<HTMLInputElement>,
) =>
  useMemo(
    () =>
      ({ id }: { id: string }) => <Site ref={opinionOfSiteValueRef} id={id} viewMode={viewMode} />,
    [opinionOfSiteValueRef, viewMode],
  );
